// extracted by mini-css-extract-plugin
export default {"smlSvg":"styles_smlSvg__G6Dlo","hero":"styles_hero__1S60Z"};